import type { ConciergeMessagePart, ShowStoreLocatorToolPart } from '../../types/conciergeToolTypes';
import { isOutputState } from './types';

/**
 * Collects all SKUs from multiple store locator parts into a single merged part.
 * Returns the merged SKU list and which part index should render the widget.
 */
export function getMergedStoreLocatorInfo(
  allParts: ConciergeMessagePart[],
): { renderIndex: number; allSkus: string[] } | null {
  const storeLocatorParts: Array<{ index: number; skus: string[] }> = [];

  allParts.forEach((p, i) => {
    if (p.type !== 'tool-show_store_locator') return;
    const slPart = p as ShowStoreLocatorToolPart;
    if (!isOutputState(slPart.state)) return;
    const output = slPart.output;
    if (!output || output.error || output.isOnlineOnly || !output.hasStores) return;
    const skus = output.stacklineSkus ?? [];
    if (skus.length > 0) {
      storeLocatorParts.push({ index: i, skus });
    }
  });

  if (storeLocatorParts.length <= 1) return null;

  const allSkus = [...new Set(storeLocatorParts.flatMap((p) => p.skus))];
  return { renderIndex: storeLocatorParts[storeLocatorParts.length - 1].index, allSkus };
}
